import { getUrlParameter } from '../../general/functions';
import { BASE_URL } from '../../general/variables';

const generateEventColour = function (type) {
  const curObj = {
    name: null,
    class: null,
  };

  switch (type) {
    // Call in admin       Call In
    // WALK IN             Walk In

    case 'CALL IN ADMIN':
      curObj.name = 'Call In';
      curObj.class = 'badge-primary';
      break;

    case 'WALK IN':
      curObj.name = 'Walk In';
      curObj.class = 'badge-primary';
      break;

    case 'WEB CONSULTATION':
      curObj.name = 'Web Consultation';
      curObj.class = 'badge-primary';
      break;

    // DM Instagram        Social Media (Instagram)
    // FACEBOOK            Social Media (Facebook)
    // Line Admin          Social Media (LINE)
    // Telegram            Social Media (Telegram)
    // Tiktok              Social Media (Tiktok)
    // TWITTER             Social Media (Twitter)

    case 'DM INSTAGRAM':
      curObj.name = 'Social Media (Instagram)';
      curObj.class = 'badge-info';
      break;
    case 'FACEBOOK':
      curObj.name = 'Social Media (Facebook)';
      curObj.class = 'badge-info';
      break;
    case 'LINE ADMIN':
      curObj.name = 'Social Media (LINE)';
      curObj.class = 'badge-info';
      break;
    case 'TELEGRAM':
      curObj.name = 'Social Media (Telegram)';
      curObj.class = 'badge-info';
      break;
    case 'TIKTOK':
      curObj.name = 'Social Media (Tiktok)';
      curObj.class = 'badge-info';
      break;
    case 'TWITTER':
      curObj.name = 'Social Media (Twitter)';
      curObj.class = 'badge-info';
      break;

    // EXPO ONLINE/VIRTUAL EDU FAIR    Event (Expo)
    // ONLINE INFOSESSION / WORKSHOP   Event (Info Session)
    // SCHOOL FAIR                     Event (Schoolfair)

    case 'EXPO ONLINE/VIRTUAL EDU FAIR':
      curObj.name = 'Event (Expo)';
      curObj.class = 'badge-warning';
      break;
    case 'ONLINE INFOSESSION / WORKSHOP':
      curObj.name = 'Event (Info Session)';
      curObj.class = 'badge-warning';
      break;
    case 'SCHOOL FAIR':
      curObj.name = 'Event (Schoolfair)';
      curObj.class = 'badge-warning';
      break;

    // DATA DARI PAK KEVIN             Others (Data dari pak Kevin)
    // ICAN English                    Others (ICAN English)
    // Online O                        Others (Online O)
    // REFERENSI                       Others (Reference)
    // SUB                             Others (Sub)
    // Swiss Education Group (SEG)     Others (SEG)
    // Web Universitas123              Others (Univ123)

    case 'DATA DARI PAK KEVIN':
      curObj.name = 'Others (Data dari Pak Kevin)';
      curObj.class = 'badge-danger';
      break;
    case 'ICAN ENGLISH':
      curObj.name = 'Others (ICAN English)';
      curObj.class = 'badge-danger';
      break;
    case 'ONLINE O':
      curObj.name = 'Others (Online O)';
      curObj.class = 'badge-danger';
      break;
    case 'REFERENSI':
      curObj.name = 'Others (Reference)';
      curObj.class = 'badge-danger';
      break;
    case 'SUB':
      curObj.name = 'Others (Sub Agent)';
      curObj.class = 'badge-danger';
      break;
    case 'SWISS EDUCATION GROUP (SEG)':
      curObj.name = 'Others (SEG)';
      curObj.class = 'badge-danger';
      break;
    case 'WEB UNIVERSITAS123':
      curObj.name = 'Others (Univ123)';
      curObj.class = 'badge-danger';
      break;
    default:
      curObj.name = type;
      curObj.class = 'badge-primary';
      break;
  }

  return curObj;
};

let formatPrograms = function (program) {
  let curProgram = '';
  let formattedProgram = '';

  // Split program
  if (program != null) {
    if (program.indexOf('-') !== false) {
      let progList = program.split(';');

      for (let i = 0; i < progList.length; i++) {
        curProgram += progList[i].split('-')[0] + ', ';
      }
    } else {
      curProgram = program;
    }

    formattedProgram = curProgram.trim().slice(0, -1) + '';
  } else {
    formattedProgram = '-';
  }

  return formattedProgram;
};

const showEditModal = function (evt) {
  let curRow = $(evt).children('[data-field="REC_ID"]');
  let curID = $(curRow).attr('aria-label');

  $.post(BASE_URL + 'DatabaseController/getStudentDetails', { id: curID }, function (resp) {
    if (resp.code == 200) {
      $('#editDatabaseModal input[name="databaseID"]').val(curID);

      $('#editDatabaseModal input[name="databaseID"]').val(resp.data.REC_ID);
      $('#editDatabaseModal input[name="editStudentEmail"]').val(resp.data.EMAIL);
      $('#editDatabaseModal input[name="editStudentName"]').val(resp.data.NAME);
      $('#editDatabaseModal input[name="editStudentPhone"]').val(resp.data.PHONE);
      $('#editDatabaseModal input[name="editParentPhone"]').val(resp.data.PHONE_ORTU);
      $('#editDatabaseModal input[name="editDatabaseLeads"][value="' + resp.data.LEADS_SCORE + '"]').prop('checked', true);

      $('#editDatabaseModal select[name="editStudentCity"]').selectpicker('val', resp.data.CITY).selectpicker('refresh');

      $('#editDatabaseModal select[name="editCountryDestination"]').val(resp.data.COUNTRY_DESTINATION);

      if (resp.data.MAJOR_INTEREST != null) {
        let curMajor = resp.data.MAJOR_INTEREST.split('-');
        let majorOption = '';

        if (curMajor.length == 1) {
          majorOption = new Option(curMajor[0], curMajor[0], true, true);
        } else {
          majorOption = new Option(curMajor[0], curMajor[1], true, true);
        }

        $('#editDatabaseModal select[name="editMajorInterest"]').append(majorOption).trigger('change');
      }

      $('#editDatabaseModal select[name="editStudentGrade"]').selectpicker('val', resp.data.GRADE_ID).selectpicker('refresh');

      if (resp.data.INTAKE_YEAR != null) {
        $('#editDatabaseModal input[name="editIntakeYear"]').selectpicker('val', resp.data.INTAKE_YEAR).selectpicker('refresh');
      }

      if (resp.data.SOURCE_ID != null) {
        $('#editDatabaseModal select[name="editDatabaseSource"]').selectpicker('val', resp.data.SOURCE_ID).selectpicker('refresh');
      }

      if (resp.data.LEADS_ID != null) {
        $('#editDatabaseModal select[name="editLeadsType"]').selectpicker('val', resp.data.LEADS_ID).selectpicker('refresh');
      }

      if (resp.data.CITY != null) {
        $('#editDatabaseModal select[name="city"]').selectpicker('val', resp.data.CITY).selectpicker('refresh');
      }

      if (resp.data.SCHOOL != null) {
        // Cek ada pemisah atau engga
        let splitStatus = resp.data.SCHOOL.indexOf('-');
        let curSchool = {
          id: null,
          text: null,
        };

        if (!splitStatus) {
          curSchool = {
            id: resp.data.SCHOOL,
            text: resp.data.SCHOOL,
          };
        } else {
          let splitChar = resp.data.SCHOOL.split('-');

          curSchool = {
            id: splitChar[1],
            text: splitChar[0],
          };
        }

        var newOption = new Option(curSchool.text, curSchool.id, false, true);

        $('#editStudentSchool').append(newOption).trigger('change');
      }

      $('#editDatabaseModal textarea[name="editStudentQuestion"]').val(resp.data.QUESTION);

      $('#editDatabaseModal select[name="editSource"]').selectpicker('val', resp.data.SOURCE);
      $('#editDatabaseModal select[name="editSource"]').selectpicker('refresh');

      $('#editDatabaseModal').modal('show');
    } else {
      Swal.fire({
        icon: 'error',
        html: 'Invalid records selected! Please try again later',
        confirmButtonText: 'Close',
        showCancelButton: false,
      });

      return;
    }
  });
};

const updateDataStatus = async function (evt, status) {
  return new Promise((resolve, reject) => {
    $.post(BASE_URL + 'DatabaseController/updateDatabaseStatus', {
      id: evt,
      status: status,
    })
      .done((resp) => resolve(resp))
      .fail((resp) => reject(resp));
  });
};

const getAssignedNames = function (evt) {
  let curNames = '';

  for (let i = 0; i < evt.length; i++) {
    let curRow = $(evt[i]).children('[data-field="NAME"]');
    let curName = $(curRow).attr('aria-label');

    curNames += `${i + 1}. <strong>${curName}</strong><br/>`;
  }

  return curNames;
};

const getSuccessNames = function (evt, type) {
  let curNames = '';

  if (evt.finished.total == 0) {
    return `No student's assigned!`;
  }

  if (type == 'success') {
    for (let i = 0; i < evt.finished.data.length; i++) {
      curNames += `${i + 1}. <strong>${evt.finished.data[i].NAME}</strong><br/>`;
    }
  } else if (type == 'error') {
    for (let i = 0; i < evt.error.data.length; i++) {
      curNames += `${i + 1}. <strong>${evt.error.data[i].NAME}</strong><br/>`;
    }
  }

  return curNames;
};

const getRecID = function (evt) {
  let idArr = [];

  for (let i = 0; i < evt.length; i++) {
    let curRow = $(evt[i]).children('[data-field="REC_ID"]');
    let curID = $(curRow).attr('aria-label');

    idArr.push(curID);
  }

  return idArr;
};

const getCustomParams = () => {
  let customParams = getUrlParameter('t');

  let extenParams = {};

  if (!customParams) {
    return {};
  }

  $('select[name="leadScoreFilter[]"]').val('').selectpicker('refresh');

  switch (customParams) {
    case 'hot-new-leads':
      extenParams = {
        ...extenParams,
        query: { LEADS_SCORE: 3 },
      };

      $('select[name="leadScoreFilter[]"]').val('3').selectpicker('refresh');
      break;
    case 'warm-new-leads':
      extenParams = {
        ...extenParams,
        query: { LEADS_SCORE: 2 },
      };

      $('select[name="leadScoreFilter[]"]').val('2').selectpicker('refresh');
      break;
    case 'cold-new-leads':
      extenParams = {
        ...extenParams,
        query: { LEADS_SCORE: 1 },
      };

      $('select[name="leadScoreFilter[]"]').val('1').selectpicker('refresh');
      break;
  }
  return extenParams;
};

export { getCustomParams, generateEventColour, getAssignedNames, getRecID, getSuccessNames, updateDataStatus, showEditModal, formatPrograms };
